import React, { useEffect, useRef } from "react";
import { createPortal } from "react-dom";

import shareIcon from "../../../assets/images/share.png";
import closeIcon from "../../../assets/images/close.png";
import arrowIconWhite from "../../../assets/images/arrowIconWhite.png";

// immagine (come richiesto, stesso path ma nome 03-02)
import Img from "../../../assets/images/sezione-05-popup-03-02-img-01.svg";

export default function PSIPopup({ isOpen, onClose }) {
  const overlayRef = useRef(null);

  useEffect(() => {
    const onKey = (e) => e.key === "Escape" && onClose?.();
    if (isOpen) {
      document.body.classList.add("overflow-hidden");
      window.addEventListener("keydown", onKey);
    }
    return () => {
      document.body.classList.remove("overflow-hidden");
      window.removeEventListener("keydown", onKey);
    };
  }, [isOpen, onClose]);

  if (!isOpen) return null;

  const onShare = (popupId) => {
    const url = new URL(window.location.href);
    url.searchParams.set("popup", popupId);

    if (navigator.share) {
      navigator
        .share({ title: "4 Principi per una Assicurazione Sostenibile", url: url.toString() })
        .catch(() => {});
    } else if (navigator.clipboard) {
      navigator.clipboard.writeText(url.toString()).catch(() => {});
    }
  };

  return createPortal(
    <div
      ref={overlayRef}
      className="fixed inset-0 z-[2400] bg-black/50 backdrop-blur-[2px] flex items-center justify-center p-3 md:p-6"
      onMouseDown={(e) => { if (e.target === overlayRef.current) onClose?.(); }}
      role="dialog"
      aria-modal="true"
      aria-label="4 Principi per una Assicurazione Sostenibile"
    >
      <div
        className="relative w-full md:w-[1280px] bg-white max-h-[90vh] overflow-y-auto overscroll-contain"
        style={{ background: "#E7E3DF", WebkitOverflowScrolling: "touch" }}
        onMouseDown={(e) => e.stopPropagation()}
      >
        {/* Header */}
        <div className="sticky top-3 z-10 flex items-center gap-2 justify-end pr-3">
          <button
            onClick={() => onShare("PSIPopup")}
            className="inline-flex h-9 w-9 items-center justify-center rounded-full text-[#0E3761] bg-white/90 border border-[#0E3761]/30 hover:bg-white transition"
            title="Condividi"
            aria-label="Condividi"
          >
            <img src={shareIcon} alt="" className="h-4 w-4" />
          </button>
          <button
            onClick={onClose}
            className="inline-flex h-9 w-9 items-center justify-center rounded-full text-[#0E3761] bg-white/90 border border-[#0E3761]/30 hover:bg-white transition"
            title="Chiudi"
            aria-label="Chiudi"
          >
            <img src={closeIcon} alt="Chiudi" className="h-4 w-4" />
          </button>
        </div>

        {/* Contenuto */}
        <div className="p-8">
          <h2 className="text-[#0E3761] text-[30px] md:text-[40px] font-normal">
            4 Principi per una Assicurazione Sostenibile
          </h2>

          <p className="text-[#0E3761] text-[16px] md:text-[24px] mt-2 leading-[1.1em]">
            Reale Group, attraverso la sua Capogruppo Reale Mutua, ha aderito ai Principles for Sustainable Insurance (PSI)
            delle Nazioni Unite nel marzo 2023. I PSI forniscono un quadro globale per il settore assicurativo per affrontare
            i rischi e le opportunità legati ai fattori ESG. Attraverso questa adesione, Reale Group si impegna a svolgere le
            sue attività lungo tutta la catena del valore assicurativa in modo responsabile, identificando, valutando,
            gestendo e monitorando i rischi e le opportunità associati ai fattori ESG. La strategia di sostenibilità di Reale
            Group è guidata dagli Obiettivi di Sviluppo Sostenibile (SDGs) delle Nazioni Unite per il 2030.
          </p>

          {/* Blocco con illustrazione assoluta + riquadro PSI */}
          <div className="relative mt-[120px]">
            {/* immagine assoluta come nel layout */}
            <img
              src={Img}
              alt=""
              className="absolute -top-20 left-4 w-[140px] md:w-[230px] md:-top-24 md:left-8 pointer-events-none select-none"
            />

            {/* riquadro colorato */}
            <div className="bg-[#BBA3C7] p-5 h-auto py-16 md:py-0 md:h-[500px] flex flex-col justify-center">

              {/* 2 colonne su desktop, 1 su mobile */}
              <div className="grid grid-cols-1 md:grid-cols-2 gap-x-10 gap-y-6 text-white">
                <div>
                  <p className="text-[16px] md:text-[20px] leading-snug">
                    <span className="font-semibold">1. Integrare nel processo decisionale</span> le
                    tematiche ambientali, sociali e di governance rilevanti per il business assicurativo.
                  </p>
                </div>
                <div>
                  <p className="text-[16px] md:text-[20px] leading-snug">
                    <span className="font-semibold">3. Lavorare insieme ai governi, alle autorità di regolamentazione e agli altri stakeholder</span>{" "}
                    principali per promuovere un’azione diffusa sulla società delle tematiche ambientali, sociali e di governance.
                  </p>
                </div>
                <div>
                  <p className="text-[16px] md:text-[20px] leading-snug">
                    <span className="font-semibold">2. Lavorare insieme ai clienti e ai business partner</span> per aumentare la
                    consapevolezza sulle tematiche ambientali, sociali e di governance, gestirne i rischi e sviluppare soluzioni.
                  </p>
                </div>
                <div>
                  <p className="text-[16px] md:text-[20px] leading-snug">
                    <span className="font-semibold">4. Dimostrare responsabilità e trasparenza</span> nel reporting verso il
                    pubblico sui progressi nell’implementazione dei Principi.
                  </p>
                </div>
              </div>
            </div>
          </div>

          {/* CTA finale */}
          <div className="mt-6">
            <a href="https://www.realegroup.eu/groupshare/0/IT/ListaSustainabilityReports/44/Bilancio%20Consolidato%20Integrato%202024.pdf#page=504" target="_blank">
              <button
                className="bt-secondary2 text-sm px-4 py-2"
              >
                <img
                  src={arrowIconWhite}
                  alt="Arrow"
                  className="inline-block mr-2 w-[20px] h-[20px]"
                />
                Consulta la Relazione PSI — cap. 8.2
              </button>
            </a>
          </div>
        </div>
      </div>
    </div>,
    document.body
  );
}
